import { Component, OnInit, ViewChild } from '@angular/core';
import { CoreService } from './core.service';

import { ChatComponent } from './chat/chat.component';
import { ChannelComponent } from './channel/channel.component';
import { AuthComponent } from './auth/auth.component';


import { NgClass, NgIf, NgFor, UpperCasePipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'


@Component({
	selector: 'app-root',
	imports: [
		FormsModule, ReactiveFormsModule,

		NgIf, //NgFor,

		TitleCasePipe,
		//UpperCasePipe, DecimalPipe, ,

		ChatComponent,
		AuthComponent,
		ChannelComponent,
	],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent {

	//Overlays Switching controll
	overlay_active: string = null;
	overlay_set( name ){
		this.overlay_active = name;
	}
	overlay_toggle( name ){
		this.overlay_active = name == this.overlay_active ? null : name;
	}

	constructor( public core: CoreService ){
		this.core.app_component = this;
	}

	ngOnInit(){
		
	}






























	oldinit(){
		let url = new URL( location.href );
		let channel = url.searchParams.get('channel');
		if( channel ){
			let m = channel.match(/(\w+)(?:-(\w+))?/);
			//loading_message['innerText'] = "Connecting to " + (m[2] ? "Channel " + m[2] : "Chat Box") + "..."
			this.core.active_channel  = channel;

			/*let hash = url.searchParams.get('hash');
			if( hash ){
				this.core.session_token = {}
				for (const [key, value] of url.searchParams['entries']())
					if( key != 'channel' )
						this.core.session_token[key] = value;
			} else if ( localStorage['JWT:' + channel.split('-')[0]] ){
				this.core.session_token = JSON.parse(localStorage['JWT:' + channel.split('-')[0]]);
			}*/
		}

		this.core.parentMessage({'event': 'ready'});
		this.core.message_event.subscribe((msg)=>{this.handleMessage(msg)})
		this.core.insert_event.subscribe((text)=>{
			let ta    = this.textarea.nativeElement;
			let start = this.message.slice(0, ta.selectionStart);
			let end   = this.message.slice(ta.selectionEnd);

			let message = start + ( start.endsWith(' ') ? '' : ' ' ) + text + ( end.startsWith(' ') ? '' : ' ' ) + end;
			this.message = message; ta.focus();

			setTimeout(() => { ta.selectionStart = ta.selectionEnd = message.length - end.length }, 10);
		});
		this.core.clear_event.subscribe(()=>{
			this.unread_count = 0;
			this.online_count = null;
			this.typing_message = '';
		})

		let tmp;
		for( let group of [] ){ //EMOJI_GROUPS
			tmp = [];
			for( let emoji of group )
				tmp.push([
					emoji[1],
					""//this.sanitizer.bypassSecurityTrustHtml(window['twemoji'].parse(String.fromCodePoint(+emoji[1])))
				])
			this.emojis.push(tmp);
		}
	}

	@ViewChild('message_box') textarea;
	stats_shown   = false; //window.innerWidth > 390;
	auth_shown    = false;
	scroll_locked = true;
	scroll_manual = false;
	unread_count  = 0;
	channel_info  = null;

	console = console;


	// ************** //
	emojis = [];
	emojibox_open = false;
	emojibox_init = false;
	appendEmoji( emoji ): void {
		if( emoji )
			this.message += String.fromCodePoint(emoji);
	}



	error_message: string  = '';
	error_message_timeout  = null;
	online_count:  number  = null;
	typing_message: string = '';
	handleMessage( msg ){
		if( msg['error'] ){
			this.error_message = msg['error'];
			if( this.error_message_timeout )
				clearTimeout(this.error_message_timeout);
			this.error_message_timeout = setTimeout(() => { this.error_message = ''; }, 3000);
		}
		if( msg['relevant_users'] ){
			this.typing_message = ''; let count = 0;

			for( let user of Object.values(msg['relevant_users']) )
				if( user['typing'] > 0 ){
					this.typing_message += (this.typing_message ? ', ' : '' ) + user['username']
					count += 1;
				}

			if( count == 1 )
				this.typing_message += ' is typing...';
			if( count >= 2 )
				this.typing_message += ' are typing...';

			if( this.typing_message.length > 25 )
				this.typing_message = `${count} people are typing...`;
		}

		if( msg['total_online'] )
			this.online_count = msg['total_online'];

		if( msg['cooldown_tuple'] )
			this.start_cooldown_countdown( msg['cooldown_tuple'] )

	}



	//Current Stack, Max Stack, Replenish time, Untill Next Stack
	cooldown_tuple: number[] = [0, 1, 1, 1];
	stack_increase_timeout   = null;
	start_cooldown_countdown( tuple ){
		if( this.stack_increase_timeout )
			clearTimeout( this.stack_increase_timeout );

		this.cooldown_tuple    = tuple;
		this.cooldown_tuple[0] = Math.floor(this.cooldown_tuple[0]);

		if( this.cooldown_tuple[0] < this.cooldown_tuple[1] ){
			this.stack_increase_timeout = setTimeout(() => {
				this.cooldown_tuple[0] += 1
				this.cooldown_tuple[3]  = this.cooldown_tuple[2];
				this.start_cooldown_countdown( this.cooldown_tuple );
			}, tuple[3] * 1000 + 1000 );
		}
	}











	//
	get is_command() { return !!this.message.match('^\s*/'); }
	last_message_timestamp: number = 0;
	message: string = '';
	sendMessage( event ): void {
		event.preventDefault();
		event.stopPropagation();

		if( this.core.ws_conn.readyState != 1 ) return;

		if( !this.is_command ){
			if( new Date().getTime() - this.last_message_timestamp < 500 && this.cooldown_tuple[0] < 2 ){ return; }
			if( this.cooldown_tuple[0] < 1 || !this.message ){ return; }

			this.last_message_timestamp = new Date().getTime();
			this.cooldown_tuple[0] -= 1
		}
		this.core.queueMessage({ 'text': this.message });
		this.message = '';
		this.emojibox_open = false;
	}



	//Typing Status Reports
	stopped_typing_timeout = null;
	last_typing_report     = 0;
	typingStatus( event ){
		if( event.key.length != 1 ) return;
		if( this.is_command ) return;

		let now = new Date().getTime();

		if( this.stopped_typing_timeout !== null ){
			clearTimeout(this.stopped_typing_timeout);
			this.stopped_typing_timeout = null;
		}

		if( now - this.last_typing_report > 5000 ){
			this.core.smartSend({ "started_typing": this.message.length })
			this.last_typing_report = now;
		}

		this.stopped_typing_timeout = setTimeout(()=>{
			this.last_typing_report     = 0;
			this.stopped_typing_timeout = null;
			this.core.smartSend({ "stopped_typing": this.message.length })
		}, 1500);
	}

}
